<template>
    <div class="view view--wallpaper-categories">
        <wallpaper-categories-list v-bind:show-filters="{ 'search': true }"
                        v-bind:show-paging="true"
                        v-bind:show-sort="true"
        />
    </div>
</template>

<script>
    import wallpaperCategoriesList from '../../../components/WallpaperCategoriesList.vue';

    export default {
        components: {
            wallpaperCategoriesList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/wallpapers/categories/Index.vue